var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.133 4.537c.754-.754 2.354-.79 3.57.427 1.217 1.217 1.181 2.817.428 3.57l-3.02 3.02a1 1 0 001.415 1.414l3.019-3.019c1.753-1.753 1.333-4.639-.427-6.399-1.76-1.76-4.646-2.18-6.4-.427L9.618 7.224c-1.753 1.753-1.333 4.64.427 6.4a1 1 0 001.414-1.415c-1.216-1.216-1.18-2.816-.427-3.57l4.102-4.102z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.623 10.044a1 1 0 00-1.414 1.415c1.217 1.216 1.181 2.816.428 3.57l-4.102 4.102c-.754.754-2.354.79-3.57-.427-1.217-1.217-1.182-2.817-.428-3.57l3.02-3.02A1 1 0 106.141 10.7l-3.02 3.019c-1.752 1.753-1.332 4.639.428 6.399 1.76 1.76 4.646 2.18 6.399.427l4.102-4.102c1.753-1.752 1.333-4.638-.428-6.399z",
    fill: "#fff"
  })));
}
export default SvgLink;